import type { FaireThemeEntity } from "../../entity_types/theme";

export const chic_on_the_go_accessories: FaireThemeEntity = {
  token: "chic-on-the-go-accessories",
  type: "theme",
  name: "Chic On-the-Go Accessories",
  description: "Functional yet fashionable items including high-capacity totes and long-hair extensions to round out your accessory collection.",
  teaser: "Since you have a distinctive interest in crossbody bags and hair sprays, these accessories offer a natural expansion for your pop-up shop's lifestyle offerings.",
  detail: "The payload features a Striped Minimalist Large Capacity Canvas Shoulder Bag and a Dark Brown Ombre Wavy Long Hair Wig, supporting a move into functional fashion.",
  bgColor: "#F5E6CC",
  tileBgColor: "#6b3a5b",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_p7twxvnm6j",
    "p_h279jqny62",
    "p_4bprnxq49z",
    "p_f3zz554kt6",
    "p_fqa5abc6j3",
    "p_td6sxyw8kb",
    "p_cejevzfng5",
    "p_ttk75jr75r",
    "p_82ehrztk7u",
    "p_rvmv6w87j9",
    "p_m5f9ntrc42",
    "p_fxn6jvmbjr",
    "p_sdewebdt4n",
    "p_z2ewfdq563",
    "p_42n546c9et",
    "p_263p462n8r",
    "p_aaez2vb2dq",
    "p_95r9me6fse",
    "p_asbwtt95gd",
    "p_4xbq9tzhj2",
    "p_nenq47vcts",
    "p_uwhthsaaew",
    "p_cyxp5y5whc",
    "p_q9ap27uc7w",
    "p_ue539fnbcd",
    "p_tx7jj6d3f8",
    "p_bwhw4edtj9",
    "p_kck7b89s3k",
    "p_6umfyrmazt",
    "p_djxr8f3xer",
    "p_x93mxzh4yt",
    "p_tx4kgrz3zp",
    "p_u4mfrqc8ac",
    "p_pkgx9p6x88",
    "p_8grqhr8zkj",
    "p_7f8wjh233s",
    "p_sqmtmtngbt",
    "p_k5hhczmne5",
    "p_uqqex2gzt8",
    "p_jnnd5v5zw9",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
